// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bS","header":"bT","message":"bU","copyMessage":"bV","button":"bW"};